export default "__VITE_ASSET__BSdr6Otx__"